<template>
    <div class="crop_offers__body__body__single borderBottom">
        <div class="row px-4">
            <div class="col-5 col-lg-5 py-3 pl-3">
                <div class="row">
                    <div class="col-4 col-lg-4">
                        <div class=" avatarBanner">
                            <!-- <span class="font-bold">OM</span> -->
                            <img :src="cropUrl" v-if="cropUrl" />
                            <img :src="`${$baseImageUrl}/banners/auth_bg.jpg`" v-else />
                        </div>
                    </div>
                    <div class="col-8 col-lg-8">
                        <h4 class="font-bold font-md">{{order.crop.name}}</h4>
                        <p class="my-1">By: {{order.crop.farm.farmer_name}}</p>
                        <p class="font-sm my-1">Date: {{ moment(order.crop.date_planted).format('DD MMMM, YYYY') }}</p>
                        <p class="font-sm my-1">Status: <span class="font-bold" :class="checkStatusColor">{{order.order.status}}</span></p>
                    </div>
                </div>
            </div>
            <div class="col-2 col-lg-2 py-3 d-flex align-items-center font-bold">{{order.quantity / 1000 | formatNumber}}</div>
            <div class="col-3 col-lg-3 py-3 d-flex align-items-center font-bold"> 
                <span class="naira mr-1"></span> {{totalAmount | formatNumber}}</div>
            <div class="col-2 col-lg-2 py-3 d-flex align-items-center">
                <router-link :to="{ name: 'offtaker.orderdetails', params: { id:order.order_id } }" 
                class="viewButton mr-4 px-0 color__primary font-bold btn py-2">View</router-link>

                <div class="dropdown">
                    <!-- <a href="#" data-toggle="dropdown" class="userAccountDetails dropdown-toggle">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="15.5" stroke="#E5E5E5" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16Z"
                                fill="#757575" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M21 16C21 14.8954 21.8954 14 23 14C24.1046 14 25 14.8954 25 16C25 17.1046 24.1046 18 23 18C21.8954 18 21 17.1046 21 16Z"
                                fill="#757575" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16Z"
                                fill="#757575" />
                        </svg>
                    </a> -->

                    <div class="dropdown-menu">
                        <ul class="dpd_nav">
                            <li>
                                <a href="profile.html">
                                    Confirm delivery
                                </a>
                            </li>
                            <li>
                                <a href="act_settings.html">
                                    Confirm Payment
                                </a>
                            </li>
                            <li>
                                <a href="../login.html">
                                    Cancel Order
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props:['order'],
    data() {
        return {
            moment
        }
    },
    computed: {
        totalAmount() {
            const total = this.order.crop.agg_kg_price * this.order.quantity
            return (total * 0.05) + total
        },
        cropUrl() {
            return this.order.crop.crop && this.order.crop.crop.image_url ? this.order.crop.crop.image_url : '';
        },
        checkStatus() {
            const { order } = this.order
            switch (order.status) {
                case 'pending':
                    return 'Awaiting confirmation';
                case 'accepted':
                    return 'Awaiting confirmation';
                case 'completed':
                    return 'Completed';
                case 'cancelled':
                    return 'Cancelled'
                default:
                    return '';
            }
            return '';
        },
        checkStatusColor() {
            const { order } = this.order
            switch (order.status) {
                case 'pending':
                    return 'color__grey'
                case 'shipped':
                    return 'color__green';
                case 'delivered':
                    return 'color__primary'
                case 'awaiting_payment':
                    return 'color__secondary' 
                case 'cancelled':
                    return 'color__grey_light'
                case 'completed':
                    return 'color__primary'
                default:
                    return ''
            }
            return ''
        }
    }
}
</script>